import React, { Component } from 'react'
import { Redirect } from 'react-router-dom'
import ReusableButton from '../../SharedComponents/Button/Button'
import ReusableTextBox from '../../SharedComponents/Textbox/Textbox'
import CoopDashboardLoginLogo from '../../Images/coopLogoDashboard.png'
import Loading from '../../Images/loading.gif'
import DashboardLogo from '../../SharedComponents/DashboardLogo/DashboardLogo'
import '../../CSS/global.css'
import './CleanersDashboardForgotPwd.css'
import { destroySession } from '../../Utility/Utility';
import * as CleanersDashboardForgotPwdConstant from './CleanersDashboardForgotPwdConstant'
import { ForgotPassword } from '../../CleanersDashboardAPI/CleanersDashboardForgotAPI'
import { ResetPassword } from '../../CleanersDashboardAPI/CleanersDashboardResetPwdAPI'
import Modal from 'react-modal';
import { IoIosClose, IoMdArrowBack } from "react-icons/io";
import { IconContext } from "react-icons";
import GreenTick from '../../Images/tick-round.png'
import bcrypt from 'bcryptjs';
const $ = require('jquery')

class CleanersDashboardForgotPwd extends Component {
    constructor(props) {
        super(props)
        this.state = {
            Username: '',
            loading: false,
            UserId: '',
            Password: "",
            FirstName: '',
            LastName: '',
            VendorName: '',
            EmailAddress: '',
            redirectCleanersDashboard: false,
            redirectLogin: false,
            OTP: '',
            RePassword: '',
            errorsOTP: '',
            errorsPassword: '',
            errorsEmail: '',
            errorsRePassword: '',
            elementIDEmail: false,
            elementOTP: false,
            elementIDRePassword: false,
            elementIDPassword: false,
            elementIDPasswordPolicy: false,
            errorsPasswordMismatch: "",
            redirectForgotSuccess: false,
            HideForgotPage: true,
            modalIsOpen: false,
            modalIsOpenPwdChanged: false,
            elementIDPasswordMismatch: false,
            elementIDRePasswordMismatch: false,
            errorsPasswordPolicy: false,
            encryptPassword: ''

        }
        this.handleOTP = this.handleOTP.bind(this);
        this.handleNewPwd = this.handleNewPwd.bind(this);
        this.handleReTypePwd = this.handleReTypePwd.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.SubmitEmail = this.SubmitEmail.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleRegisterEmail = this.handleRegisterEmail.bind(this);
        this.openModal = this.openModal.bind(this);
        this.afterOpenModal = this.afterOpenModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.handleSuccessOk = this.handleSuccessOk.bind(this);
        this.openModalPwdChanged = this.openModalPwdChanged.bind(this);
        this.afterOpenModalPwdChanged = this.afterOpenModalPwdChanged.bind(this);
        this.closeModalPwdChanged = this.closeModalPwdChanged.bind(this);
        this.handleSuccessOk = this.handleSuccessOk.bind(this);
        this.handleBackForgot = this.handleBackForgot.bind(this);
        // this.handlePaste = this.handlePaste.bind(this);
    }

    UNSAFE_componentWillMount() {
        this.setState({
            encryptPassword: sessionStorage.getItem('encryptedPassword')
        })
        // let AuthData= sessionStorage.getItem("email")
        //    if(sessionStorage.getItem("ForgotPwd")) {

        //    }
    }
    //     handlePaste (e) {
    // 		var clipboardData, pastedData;

    // 		// Stop data actually being pasted into div
    // 		e.stopPropagation();
    //     e.preventDefault();

    // 		// Get pasted data via clipboard API
    //     clipboardData = e.clipboardData || window.clipboardData;
    //     pastedData = clipboardData.getData('Text');

    //     // Do whatever with pasteddata
    //     alert(pastedData);
    // }
    // componentWillUnmount() {
    //     document.removeEventListener('paste', this.handlePaste);
    //   }
    componentDidMount() {

        // let el =  document.getElementsByClassName('OTPField')
        // console.log(el[0])
        // el.addEventListener('paste', this.handlePaste);
        // $(".OTPField").bind('cut copy paste', function(e) {
        //     e.preventDefault();
        //   return false;
        // });
        var self = this;
        $(".PwdField").keypress(function (e) {
            if (e.which == 13) {
                self.SubmitEmail();
            }
        });

        // $(".PwdFieldSubmit").keypress(function(e) {
        //     if(e.which == 13) {
        //         self.handleSubmit();
        //     }
        // });
    }
    handleBackForgot() {
        this.setState({
            redirectLogin: true
        })
    }
    handleSuccessOk = (e) => {
        this.setState({
            HideForgotPage: false,
            modalIsOpen: false
        });
    }
    handleRegisterEmail = (e) => {
        this.setState({
            EmailAddress: e.target.value
        })
        this.onKeyPressEmail();
    }
    openModal() {
        this.setState({
            modalIsOpen: true,
        });
    }

    afterOpenModal() {
    }

    closeModal() {
        this.setState({
            modalIsOpen: false,
        });
    }
    openModalPwdChanged() {
        this.setState({
            modalIsOpenPwdChanged: true,
        });
    }

    afterOpenModalPwdChanged() {
    }

    closeModalPwdChanged() {
        this.setState({
            modalIsOpenPwdChanged: false,
            redirectLogin: true
        });
    }
    handleOTP = (evt) => {
        this.setState({
            OTP: evt.target.value
        })
    }
    handleNewPwd = (e) => {
        this.setState({
            Password: e.target.value
        })
    }
    handleReTypePwd = (e) => {
        this.setState({
            RePassword: e.target.value
        })
    }
    handleCancel = (e) => {
        sessionStorage.removeItem('encryptedPassword')
        this.setState({
            redirectLogin: true
        })
    }
    onKeyPressEmail = e => {
        if (this.state.EmailAddress.length < 0) {
            this.setState({
                elementIDEmail: true
            });
        }
        else {
            this.setState({
                elementIDEmail: false
            });
        }
    };
    onKeyPressOTP(e) {
        var regex = /[0-9]{1,6}/
        var key = String.fromCharCode(!e.charCode ? e.which : e.charCode);
        var Cond = regex.test(key)
        if (Cond) {
            if (this.state.OTP.length < 0) {
                this.setState({
                    elementOTP: true
                });
            }
            else {
                this.setState({
                    elementOTP: false
                });
            }
        }
        else {
            e.preventDefault();
            return false;
        }
    }
    onKeyPressPassword = e => {
        if (this.state.Password.length < 0) {
            this.setState({
                elementIDPassword: true
            });
        }
        else {
            this.setState({
                elementIDPassword: false
            });
        }
    };
    onKeyPressRePwd = e => {
        if (this.state.RePassword.length < 0) {
            this.setState({
                elementIDRePassword: true
            });
        }
        else {
            this.setState({
                elementIDRePassword: false
            });
        }
    };
    SubmitEmail = (e) => {
        var loginEmail = sessionStorage.getItem('email')
        if (this.state.EmailAddress == "") {
            let errorsEmail = ''
            errorsEmail = CleanersDashboardForgotPwdConstant.emptyEmail
            this.setState({
                elementIDEmail: true,
                errorsEmail: errorsEmail,
                loading: false
            })
        }

        else if ((this.state.EmailAddress) != (loginEmail)) {
            let errorsEmail = ''
            errorsEmail = CleanersDashboardForgotPwdConstant.InvalidEmail
            this.setState({
                elementIDEmail: true,
                errorsEmail: errorsEmail,
                loading: false
            })
        }
        else {
            this.setState({
                loading: true
            })
            ForgotPassword(loginEmail).then(res => {
                let responseJSON = res;
                if (responseJSON.status === 200) {
                    this.setState({
                        loading: false
                    })
                    this.openModal();
                }
                else if (responseJSON.status === 404) {

                }
            })
        }
    }
    handleSubmit = (e) => {
        var Regex = /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{8,}$/
        var Cond = Regex.test(this.state.Password);
        let apiFlag = true
        var HidePwdPolicy = false
        let AuthData = {
            OTP: this.state.OTP,
            Password: this.state.Password,
            RePassword: this.state.RePassword,
        }
        if ((AuthData.Password) == (AuthData.RePassword)) {
            if (AuthData.OTP == "") {
                let errorsOTP = ''
                errorsOTP = CleanersDashboardForgotPwdConstant.emptyOTP
                this.setState({
                    elementOTP: true,
                    errorsOTP: errorsOTP,
                    loading: false
                })
                apiFlag = false
            }
            if (AuthData.Password == "") {
                let errorsPassword = ''
                errorsPassword = CleanersDashboardForgotPwdConstant.emptyPassword
                this.setState({
                    elementIDPassword: true,
                    errorsPassword: errorsPassword,
                    loading: false
                })
                apiFlag = false
                HidePwdPolicy = true
            }
            if (AuthData.RePassword == "") {
                let errorsRePassword = ''
                errorsRePassword = CleanersDashboardForgotPwdConstant.emptyRePassword
                this.setState({
                    elementIDRePassword: true,
                    errorsRePassword: errorsRePassword,
                    loading: false
                })
                apiFlag = false
            }
            if (!(Cond)) {
                let errorsPasswordPolicy = ''
                errorsPasswordPolicy = CleanersDashboardForgotPwdConstant.emptyPasswordPolicy
                this.setState({
                    elementIDPasswordPolicy: true,
                    elementIDPasswordMismatch: false,
                    elementIDRePasswordMismatch: false,
                    errorsPasswordPolicy: errorsPasswordPolicy,
                    loading: false
                })
                apiFlag = false
            }
            if ((HidePwdPolicy)) {
                this.setState({
                    elementIDPasswordPolicy: false,
                    elementIDPasswordMismatch: false
                })
            }
            if (apiFlag) {
                let AuthDataAPI = {
                    OTP: this.state.OTP,
                    NewPassword: this.state.Password,
                    UserEmail: sessionStorage.getItem("email")
                }
                this.setState({
                    loading: true,
                    elementIDPasswordMismatch: false,
                    elementIDRePasswordMismatch: false
                })
                var that = this;
                bcrypt.genSalt(10, (err, salt) => {
                    bcrypt.hash(AuthDataAPI.NewPassword, salt, (err, hash) => {
                        bcrypt.compare(AuthDataAPI.NewPassword, that.state.encryptPassword, function (err, res) {
                            if (!(res)) {
                                AuthDataAPI.NewPassword = hash
                                ResetPassword(AuthDataAPI).then(res => {
                                    let responseJSON = res;
                                    if (responseJSON.data.description == "Invalid User Data") { /* Backend Custom Error for Invalid Passcode or OTP*/
                                        let errorsOTP = ''
                                        errorsOTP = CleanersDashboardForgotPwdConstant.emptyInvalidPasscode
                                        that.setState({
                                            elementOTP: true,
                                            errorsOTP: errorsOTP,
                                            loading: false
                                        })
                                    }
                                    if (responseJSON.data.description == "Token Expired") { /* Backend Custom Error for OTP Expire*/
                                        let errorsOTP = ''
                                        errorsOTP = CleanersDashboardForgotPwdConstant.TokenExpire
                                        that.setState({
                                            elementOTP: true,
                                            errorsOTP: errorsOTP,
                                            loading: false
                                        })
                                    }
                                    if (responseJSON.status === 200) {
                                        that.setState({
                                            loading: false,
                                        })
                                        that.openModalPwdChanged();
                                        sessionStorage.removeItem('encryptedPassword')
                                    }
                                    else if (responseJSON.status === 404) {
                                    }
                                })
                            }
                            else {
                                let errorsPassword = ''
                                errorsPassword = CleanersDashboardForgotPwdConstant.errNewPwd
                                that.setState({
                                    elementIDPassword: true,
                                    errorsPassword: errorsPassword,
                                    loading: false
                                })
                            }
                        })
                    })
                })

            }
        }
        else {
            let errorsPasswordMismatch = ''
            errorsPasswordMismatch = CleanersDashboardForgotPwdConstant.emptyPasswordMismatch
            this.setState({
                elementIDPasswordMismatch: true,
                elementIDRePasswordMismatch: true,
                errorsPasswordMismatch: errorsPasswordMismatch,
                loading: false,
                elementIDPasswordPolicy: false,
                elementIDPassword: false
            })
        }
    }


    render() {
        if (this.state.redirectLogin) {
            return (<Redirect to={'/DashboardLogin'} />)
        }
        return (
            <div>
                {this.state.loading ?
                    <div className="overlay"><img src={Loading} alt="Loading" className="loadingSignOut" /></div> : null}
                <div className="DashboardLoginRootDivForgot" id="rootDiv">
                    <div className="DashboardLoginDivHeaderForgot">
                        <DashboardLogo />
                        <h2>{CleanersDashboardForgotPwdConstant.visit}</h2>
                        <p>{CleanersDashboardForgotPwdConstant.cleaning}</p>
                    </div>
                    {this.state.HideForgotPage ?
                        <div className="DashboardLoginDivHeaderForGot">
                            <IoMdArrowBack className="BackIcon" onClick={this.handleBackForgot} />
                            <h1>{CleanersDashboardForgotPwdConstant.ForgotPassword}</h1>
                            <p>{CleanersDashboardForgotPwdConstant.RegisterEmail}</p>
                            <p>{CleanersDashboardForgotPwdConstant.enterRegisterEmail}</p>
                            {this.state.elementIDEmail ? <span className="errorEmail">{this.state.errorsEmail}</span> : null}
                            <ReusableTextBox className="PwdField" onChange={this.handleRegisterEmail} onKeyPress={button => this.onKeyPressEmail(button)} type="text" />
                            <ReusableButton onClick={this.SubmitEmail} buttonText={CleanersDashboardForgotPwdConstant.Submit} className="CancelFieldEmail" />
                        </div> : null}
                    {this.state.HideForgotPage ? null :
                        <div id="UsernameField">
                            <div className="DashboardLoginDivHeaderForGot">
                                <h1>{CleanersDashboardForgotPwdConstant.ForgotPassword}</h1>
                                <p>{CleanersDashboardForgotPwdConstant.OTP}</p>
                                <p class="required">{CleanersDashboardForgotPwdConstant.EnterOTP}</p>
                                {this.state.elementOTP ? <span className="errorEmail">{this.state.errorsOTP}</span> : null}
                                <ReusableTextBox className="OTPField" onChange={this.handleOTP} onKeyPress={e => this.onKeyPressOTP(e)} type="text" maxlength="6" />
                                <p class="required">{CleanersDashboardForgotPwdConstant.EnterNewPassword}</p>

                                {this.state.elementIDPassword ? <span className="errorEmail">{this.state.errorsPassword}</span> : null}
                                {this.state.elementIDPasswordMismatch && this.state.elementIDRePasswordMismatch ? <span className="errorEmail">{this.state.errorsPasswordMismatch}</span> : null}
                                {this.state.elementIDPasswordPolicy ? <span className="errorEmail">{this.state.errorsPasswordPolicy}</span> : null}
                                <ReusableTextBox className="PwdField" onChange={this.handleNewPwd} onKeyPress={button => this.onKeyPressPassword(button)} type="password" />
                                <div className="Password">
                                    <span className="PwdPolicy">{CleanersDashboardForgotPwdConstant.PasswordPolicy1}</span><br />
                                    <span className="PwdPolicy">{CleanersDashboardForgotPwdConstant.PasswordPolicy2}</span>
                                </div>
                                <p class="required">{CleanersDashboardForgotPwdConstant.RetypePassword}</p>
                                {this.state.elementIDRePassword ? <span className="errorEmail">{this.state.errorsRePassword}</span> : null}
                                {this.state.elementIDRePasswordMismatch && this.state.elementIDRePasswordMismatch ? <span className="errorEmail">{this.state.errorsPasswordMismatch}</span> : null}
                                <ReusableTextBox className="PwdField" id="EnterSubmit" onChange={this.handleReTypePwd} onKeyPress={button => this.onKeyPressRePwd(button)} type="password" />
                                <div className="ForgotButtons">
                                    <ReusableButton onClick={this.handleSubmit} buttonText={CleanersDashboardForgotPwdConstant.Submit} className="SubmitField" />
                                    <ReusableButton onClick={this.handleCancel} buttonText={CleanersDashboardForgotPwdConstant.Cancel} className="CancelField" />
                                </div>
                            </div>
                        </div>}
                    <Modal
                        isOpen={this.state.modalIsOpen}
                        onAfterOpen={this.afterOpenModal}
                        onRequestClose={this.closeModal}
                        className="Modal"
                        contentLabel="Example Modal"
                        ariaHideApp={false}
                    >
                        <IconContext.Provider
                            value={{ color: 'grey', className: "global-class-name" }}
                        >
                            <IoIosClose onClick={this.closeModal} />
                        </IconContext.Provider>
                        <img src={GreenTick} className="SuccessTick" />
                        <div className="ModalContent">
                            <p className="boldContent">{CleanersDashboardForgotPwdConstant.Success}</p>
                        </div>
                        <p className="ModalP">{CleanersDashboardForgotPwdConstant.Email}</p>
                        <p className="ModalP">{CleanersDashboardForgotPwdConstant.Passcode}</p>
                        <ReusableButton className="CancelFieldModal" buttonText="Ok" onClick={this.handleSuccessOk} />
                    </Modal>
                    <Modal
                        isOpen={this.state.modalIsOpenPwdChanged}
                        onAfterOpen={this.afterOpenModalPwdChanged}
                        onRequestClose={this.closeModalPwdChanged}
                        className="Modal"
                        contentLabel="Example Modal"
                        ariaHideApp={false}
                    >
                        <IconContext.Provider
                            value={{ color: 'grey', className: "global-class-name" }}
                        >
                            <IoIosClose onClick={this.closeModalPwdChanged} />
                        </IconContext.Provider>
                        <img src={GreenTick} className="SuccessTick" />
                        <div className="ModalContent">
                            <p className="boldContent">{CleanersDashboardForgotPwdConstant.Success}</p>
                        </div>
                        <p className="ModalP">{CleanersDashboardForgotPwdConstant.PwdChanged}</p>
                    </Modal>
                </div>
            </div>
        )
    }
}

export default CleanersDashboardForgotPwd
